import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import './index.css';
import App from './App';

let environment;

if (window.location.hostname.endsWith('.pubnub.com')) {
  environment = 'production';
} else if (window.location.hostname.endsWith('.integration.ps.pn')) {
  environment = 'integration';
}

if (environment !== 'development') {
  Sentry.init({
    dsn: 'https://0373f78ac6a34f2aa6674efc7a2a6f2a@portal-sentry.pubnub.com/5',
    release: window._REVISION_,
    environment: environment
  });
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js